/* LensAdvisor product page — scroll reveal across the split sections. */
(function () {
  const init = () => {
    const roots = document.querySelectorAll('.la-product');
    if (!roots.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = [];
    roots.forEach((root) => {
      root.querySelectorAll('.la-prod-title, .la-prod-excerpt, .la-prod-actions, .la-prod-related-card, .la-prod-close-inner > div').forEach((el) => {
        if (!el.dataset.laReveal) {
          el.dataset.laReveal = '1';
          targets.push(el);
        }
      });
    });
    if (!targets.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.animate(
          [
            { opacity: 0, transform: 'translateY(14px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 650, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'both' }
        );
        io.unobserve(e.target);
      });
    }, { threshold: 0.12 });
    targets.forEach((el) => { el.style.opacity = '0'; io.observe(el); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
